import * as React from 'react';
import styled from '@emotion/styled';
import { TagInfo } from '../TagInfo';
import { DevicesDropDown } from './DevicesDropDown';
import { AnimatedEllipsis } from './AnimatedEllipsis';
import { RotatorTagInputAndPreview } from './RotatorTagInputAndPreview';
import {useParams} from "react-router";
export const UnitHeader: React.FunctionComponent<{ tagInfo: TagInfo }> = ({ tagInfo }) => {

    const { type } = useParams<{type?: string}>();

    return <UnitHeaderContainer>
        <PreviewAndInfoContainer>
            { type === "placement-tag" ? <RotatorTagInputAndPreview/>  : <></>}
            {tagInfo ? <UnitInfoContainer>
                {!!tagInfo.preset && <>
                    <UnitHeaderProperty propertyName={'Preset'} propertyValue={tagInfo.preset} />
                    <UnitHeaderSeparator/>
                </>}
                {!!tagInfo.campaignName && <>
                    <UnitHeaderProperty propertyName={'Campaign'} propertyValue={tagInfo.campaignName} />
                    <UnitHeaderSeparator/>
                </>}
                <UnitHeaderProperty propertyName={'Video'} propertyValue={tagInfo.unitName}/>
            </UnitInfoContainer>:<AnimatedEllipsis/>}
        </PreviewAndInfoContainer>
      <DevicesDropDown/>
    </UnitHeaderContainer>;
};

const UnitInfoContainer = styled.div`
  display: flex;
  align-items: center;
  flex-direction: row;
`;

const PreviewAndInfoContainer = styled.div`
  flex-direction: row;
  display: flex;
  justify-content: space-between;
  padding-left: 1.5%;
`;

const UnitHeaderProperty = ({ propertyName, propertyValue }) =>
    (<UnitInfoProp>
        <TitlePropertyName>{propertyName}</TitlePropertyName>
        <TitlePropertyValue>{propertyValue}</TitlePropertyValue>
    </UnitInfoProp>);


const UnitInfoProp = styled.div`
  display: flex;
  align-items: baseline;
  flex-direction: row;
`;

const TitlePropertyName = styled.span`
  white-space: nowrap;
  font-family: proximanova-medium;
  margin: 0 0.6vw 0 0 ;
  color: rgba(0, 0, 0, 0.85);
  font-size: 0.85vw;
`;

const TitlePropertyValue = styled.span`
  font-family: proximanova-regular;
  white-space: nowrap;
  font-size: 0.85vw;
  margin:0;
`;

const UnitHeaderContainer = styled.div`
  position: relative;
  height: 5vh;
  width: 100%;
  background-color: #FFFFFF;
  box-shadow: 0 0 8px 0 rgba(0,0,0,0.15);
  flex-direction: row;
  display: flex;
  justify-content: space-between;
`;

const UnitHeaderSeparator = styled.div`
  height: 40%;
  padding-left: 1px;
  margin: 0 2% 0 2%;
  background-color: #E2E2E2;
`;

